<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="banner"></banner>
	<enterTitle></enterTitle>
    <div class="warp mb-60 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection(7)"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree :data="data" show-checkbox node-key="id"> </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
          <h3 class="tips">企业资质</h3>
          <div class="mt-20 qualifications_box"  v-if="userInfo.companyQualification !=undefined && JSON.parse(userInfo.companyQualification).length>0">
              <el-carousel
                :interval="4000"
                type="card"
                :autoplay="false"
                height="200px"
                width="800px"
                indicator-position="none"
              >
                <el-carousel-item v-for="(item, index) in userInfo.companyQualification &&
                JSON.parse(userInfo.companyQualification)" :key="index">
                  <viewer>
                    <img class="viewer_img" :src="item.url" />
                  </viewer>
                </el-carousel-item>
              </el-carousel>
            </div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>
<script>
import{addCollection} from "@/api/coment"
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise";
import banner from "../../common/banner";
import needsList from "../../components/needsList";
import baseInfo from "@/components/companyintroCard";
import enterTitle from '../../common/enterTitle.vue'
export default {
  components: {
    footCom,
    headEnterprise,
    banner,
    needsList,
    baseInfo,
	  enterTitle
  },
  data() {
    return {
      banner: {
        title: "企业资质",
        isShow: false,
        isColor: true,
        type:'',
        usertype:'',
        companytype:'',
        bannerUrl:'',
      },
      data: [],
    };
  },
  created(){
     this.$store.dispatch("company/getBaseInfo");
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    },
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        if (val.userId) {
           this.banner.bannerUrl = val.banner;
        }
      },
      immediate: true,
    },
  },
  methods: {
    //产品收藏
    goCollection(goodsType){
      let params ={
        goodsId:this.id,
        goodsType:goodsType
      }
      addCollection(params).then((res)=>{
        if(res.code ==0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{

      })
    },
  },
};
</script>
<style scoped lang='less'>
.el-main {
  text-align: inherit;
}
.tips {
  position: relative;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  padding-left: 10px;
  margin-bottom: 10px;
  &::before {
    position: absolute;
    left: 0;
    bottom: 4px;
    display: inline-block;
    content: "";
    width: 5px;
    height: 23px;
    background: #ff7302;
  }
}
.qualifications_list {
  display: flex;
  flex-wrap: wrap;
  li {
    width: 32%;
    margin-right: 2%;
    margin-bottom: 20px;
    &:nth-child(3n){
      margin-right: 0;
    }
  }
}
.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}
.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.el-tree {
  background: #f8f8f8;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20{
  margin-top: 20px;
}
.mt-30{
  margin-top: 30px;
}
.mb-60 {
  margin-bottom: 60px;
}
.viewer_img{
  height: 180px;
  display: flex;
  justify-content: center;
  align-items:center;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_qualifications.vue